import { ActionIcon, Grid, Group, Stack, Text, Image } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { PaperWithBorder } from 'components/PaperWithBorder';
import { appPageUrl, appVersion, appVersionDate, shortSha, showUsaFeature, udiLabel } from 'utils/app';
import dayjs from 'dayjs';
import manufacturerLogo from 'assets/images/manufacturer.svg';
import ceLogo from 'assets/images/CE.svg';
import mdLogo from 'assets/images/md.svg';
import cautionLogo from 'assets/images/caution.svg';
import eIfuLogo from 'assets/images/eIFU-green.svg';
import { colors } from '../../../styles';

export const About = () => {
  const { t } = useTranslation();
  const ifuHref = `${appPageUrl}/ifu/web/${showUsaFeature ? 'us/' : ''}`;

  return (
    <Grid>
      <Grid.Col span={6}>
        <PaperWithBorder data-testid={'about-page'}>
          <Stack gap={0} align={'center'} mb={20}>
            <Group justify={'center'} gap={5}>
              <Text>{`${t('application_name_label')} ${showUsaFeature ? 'US' : 'EU'} v${appVersion} -`}</Text>
              <Text fw={'bold'}>{`${t('commit_label')} ${shortSha}`}</Text>
            </Group>
            <Text size={'md'} ta={'center'} mt={'lg'} data-testid={'label-tagline'}>
              {t('application_tagline_label')}
            </Text>
          </Stack>
          <Group justify={'center'} mb={20}>
            <Image h={'60px'} w={'60px'} src={manufacturerLogo} data-testid={'image-manufacturer'} />
            <Stack gap={0} data-testid={'text-manufacturer'}>
              <Text>{'Qompium NV '}</Text>
              <Text>{'Kempische Steenweg 303/27'}</Text>
              <Text>{'3500 Hasselt BE'}</Text>
              <Text>{`${dayjs(new Date(appVersionDate)).format('YYYY-MM')}`}</Text>
            </Stack>
          </Group>
          <Group justify={'center'} align={'flex-start'} mb={20} mt={50}>
            {showUsaFeature ? (
              <Text fz={'xl'} fw={800} c={colors.turquoise[4]}>
                {'Rx ONLY'}
              </Text>
            ) : (
              <>
                <Image h={'60px'} w={'55px'} mt={5} src={ceLogo} data-testid={'image-ce'} />
                <Image h={'40px'} w={'60px'} src={mdLogo} data-testid={'image-md'} />
              </>
            )}
            <Image h={'50px'} w={'50px'} mt={-5} src={cautionLogo} data-testid={'image-caution'} />
            <Stack align={'center'} justify={'center'} gap={5} mt={-5} data-testid={'stack-ifu'}>
              <ActionIcon
                component={'a'}
                href={ifuHref}
                target={'_blank'}
                variant={'outline'}
                size={54}
                radius={'xl'}
                data-testid={'action-ifu'}
                color={'var(--mantine-color-turquoise-5)'}
              >
                <Image w={'30px'} src={eIfuLogo} data-testid={'image-ifu'} />
              </ActionIcon>
            </Stack>
          </Group>
          <Text ta={'center'} fw={'bold'} data-testid={'label-udi'}>{`UDI: ${udiLabel}`}</Text>
        </PaperWithBorder>
      </Grid.Col>
    </Grid>
  );
};
